export default __webpack_public_path__ + "static/media/q_mark.8edd082f.png";